import { Controller } from "../Controller";
import { ControllerRegistry } from "../../Registry/ControllerRegistry";
import { Item } from "../../HTML/Menu/Item";

export class MenuItem extends Controller {
    /**
     * @param data
     */
    protected initialize(data: Map<any, any>) {
        super.initialize(data);
        if (! data.has("no-init")) {
            this.addToData( "tag", new Item(data));
        }
    }
}

ControllerRegistry.register("MenuItem", MenuItem);
